import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "#FFF",
            d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 2.5C10.335 2.5 2.5 10.335 2.5 20S10.335 37.5 20 37.5 37.5 29.665 37.5 20 29.665 2.5 20 2.5zm8.642 5.833c1.67 0 3.025 1.355 3.025 3.025v17.284c0 1.67-1.355 3.025-3.025 3.025H11.358c-1.67 0-3.025-1.355-3.025-3.025V11.358c0-1.67 1.355-3.025 3.025-3.025zm0 2.593H11.358c-.239 0-.432.193-.432.432v17.284c0 .239.193.432.432.432h17.284c.239 0 .432-.193.432-.432V11.358c0-.239-.193-.432-.432-.432zM20 13.086c3.818 0 6.914 3.096 6.914 6.914 0 3.818-3.096 6.914-6.914 6.914-3.818 0-6.914-3.096-6.914-6.914 0-3.818 3.096-6.914 6.914-6.914zm0 2.593c-2.386 0-4.321 1.935-4.321 4.321 0 2.386 1.935 4.321 4.321 4.321 2.386 0 4.321-1.935 4.321-4.321 0-2.386-1.935-4.321-4.321-4.321zm6.481-3.457c.716 0 1.297.58 1.297 1.297 0 .715-.58 1.296-1.297 1.296-.715 0-1.296-.58-1.296-1.296 0-.716.58-1.297 1.296-1.297z",
            transform: "translate(-1248 -344) translate(1248 344)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }